module.exports = __webpack_public_path__ + "static/img/validator_top_img.fd64002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/validator/validator_top_img.png
// module id = yBXk
// module chunks = 1